import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import "./AllPages.css";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { ActionFormatterComponent, statusFormatter, videoFormatter } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { findUploadName } from "../../../components/CommonMethod/CommonMethods";
import { toast } from "react-toastify";
import { connect } from "react-redux";
function AllPages({ siteTheme }) {

  const baseURL = process.env.REACT_APP_Baseurl
  const userAccessToken = getItemToken('access_token');
  const labelSource = 'page-setting'

  const deleteApi = `${baseURL}/admin/page/multi-delete`
  const getApi = `${baseURL}/admin/page/index`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const languageApi = `${baseURL}/admin/User-Translate-Language`
  const headers = getItemToken('access_token');
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [languageCode, setLanguageCode] = useState('');
  useEffect(() => {
    if (siteTheme) {
      //console.log("siteTheme loaded:", siteTheme);
      //alert(siteTheme?.translate_checkout)
    }
  }, [siteTheme]);
  useEffect(() => {
    const fetchLanguageCode = async () => {
      try {
        const { data } = await axios.get(languageApi, { headers });
        if (data?.status) {
          const language = data?.Language_Code || 'en'; // fallback to 'en' or another default if needed
          setLanguageCode(language);
        } else {
          console.warn('Unexpected API response format:', data);
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error.message || 'Unknown error';
        console.error('Error fetching language code:', errorMsg);
      }
    };
    fetchLanguageCode();
  }, []);

  const columns = [
    {
      dataField: "title",
      text: "Pages",
      formatter: (cell, row) => videoFormatter(cell, row, siteTheme, languageCode),
    },
    {
      dataField: "slug",
      text: "Url",
    },
    {
      dataField: "active",
      text: "Status",
      formatter: (cell, row) => statusFormatter(cell, row),
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} link={"/edit-page/"} action={singleDelete} />,
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '30px' },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${getApi}`, { headers: userAccessToken });
      const result = response?.data?.pages;
      const updatedList = result?.map((item) => {
        const UploadStatus = findUploadName(item?.uploaded_by);
        const statusMaker = item?.active == 1 ? "PUBLISHED" : "UNPUBLISHED"
        return { ...item, uploaded_by: UploadStatus, active: statusMaker };
      });
      setApiData(updatedList);
      setFilteredData(updatedList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${deleteApi}`, {
        headers: userAccessToken,
        data: { id: [...itemToDelete] },
      });
      const result = response?.data;
      if (result?.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setItemToDelete([])
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: userAccessToken });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const closeModal = () => {
    setModelClose(!closeModal);
    setItemToDelete([]);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const handleFilterChange = (data) => {
    setFilteredData(data);
  };

  useEffect(async () => {
    await fetchData();
    await labelFetch()
  }, [withOutRefresh]);

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      <AdminNavbar heading={labelDisplay?.[0]?.title} totalDataLength={apiData?.length} deleteCount={itemToDelete?.length} navigation={"/add-page"} deleteMethod={openModal} navText={labelDisplay?.[1]?.title} />
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
        <AdminHeader
          searchMethod={handleFilterChange}
          exportpage={true}  // This hides the export button
          reduceData={filteredData}
          originalData={apiData}
          fileName={'page-list'}
          customPage
        />
        <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" selectRow={selectRow} selectAll={selectAll} />
      </div>
    </>
  );
}
const mapStateToProps = (state) => ({
  siteTheme: state.siteTheme.siteTheme
});

export default connect(mapStateToProps)(AllPages)